var render = function () {
  var _vm$user, _vm$user$roles$data$;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "faq-contact"
  }, [_c('b-row', {
    staticClass: "pt-75 text-center"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "faq-contact-card hover-card py-3"
  }, [_c('b-link', {
    staticClass: "d-flex flex-column align-items-center justify-content-center h-100",
    attrs: {
      "href": "https://www.youtube.com/@taskfino",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('div', {
    staticClass: "icon-circle youtube-gradient mb-2"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "50",
      "height": "50",
      "viewBox": "0 0 24 24",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.498 6.186a2.978 2.978 0 0 0-2.099-2.104C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.399.582a2.978 2.978 0 0 0-2.099 2.104C0 8.092 0 12 0 12s0 3.908.502 5.814a2.978 2.978 0 0 0 2.099 2.104C4.5 20.5 12 20.5 12 20.5s7.5 0 9.399-.582a2.978 2.978 0 0 0 2.099-2.104C24 15.908 24 12 24 12s0-3.908-.502-5.814zM9.75 15.568V8.432L15.568 12 9.75 15.568z"
    }
  })])]), _c('h5', {
    staticClass: "font-weight-bold text-dark"
  }, [_vm._v("Watch Tutorials")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Learn from our YouTube channel")])])], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "sm": "6"
    }
  }, [_c('b-card', {
    staticClass: "faq-contact-card hover-card py-3"
  }, [_c('b-link', {
    staticClass: "d-flex flex-column align-items-center justify-content-center h-100",
    attrs: {
      "href": "https://docs.taskfino.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('div', {
    staticClass: "icon-circle doc-gradient mb-2"
  }, [_c('feather-icon', {
    staticClass: "text-white",
    attrs: {
      "icon": "BookOpenIcon",
      "size": "26"
    }
  })], 1), _c('h5', {
    staticClass: "font-weight-bold text-dark"
  }, [_vm._v("Read Documentation")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Step-by-step guides & API reference")])])], 1)], 1)], 1)], 1), _c('section', {
    attrs: {
      "id": "faq-search-filter"
    }
  }, [_c('b-card', {
    staticClass: "faq-search",
    style: {
      backgroundImage: "url(".concat(_vm.bannerImage, ")")
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "4rem !important"
    }
  }, [_c('h2', {
    staticClass: "text-primary"
  }, [_vm._v(" Let's answer some questions ")]), _c('b-card-text', {
    staticClass: "mb-2"
  }, [_vm._v(" or choose a category to quickly find the help you need ")]), _c('b-form', {
    staticClass: "faq-search-input"
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "id": "searchbar",
      "placeholder": "Search faq..."
    },
    model: {
      value: _vm.faqSearchQuery,
      callback: function callback($$v) {
        _vm.faqSearchQuery = $$v;
      },
      expression: "faqSearchQuery"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    attrs: {
      "id": "faq-tabs"
    }
  }, [_c('b-tabs', {
    attrs: {
      "vertical": "",
      "content-class": "col-12 col-md-8 col-lg-9",
      "pills": "",
      "nav-wrapper-class": "faq-navigation col-md-4 col-lg-3 col-12",
      "nav-class": "nav-left"
    },
    scopedSlots: _vm._u([{
      key: "tabs-end",
      fn: function fn() {
        return [_c('b-img', {
          staticClass: "d-none d-md-block mt-auto",
          attrs: {
            "fluid": "",
            "src": require('@/assets/images/illustration/faq-illustrations.svg')
          }
        })];
      },
      proxy: true
    }])
  }, _vm._l(_vm.faqData, function (categoryObj, categoryName, index) {
    return _c('b-tab', {
      key: categoryName,
      attrs: {
        "active": !index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('feather-icon', {
            staticClass: "mr-1",
            attrs: {
              "icon": categoryObj.icon,
              "size": "18"
            }
          }), _c('span', {
            staticClass: "font-weight-bold"
          }, [_vm._v(_vm._s(categoryObj.title))])];
        },
        proxy: true
      }], null, true)
    }, [_c('faq-question-answer', {
      attrs: {
        "options": categoryObj
      }
    })], 1);
  }), 1)], 1), ((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : (_vm$user$roles$data$ = _vm$user.roles.data[0]) === null || _vm$user$roles$data$ === void 0 ? void 0 : _vm$user$roles$data$.admin) === 1 ? _c('section', {
    staticClass: "faq-contact"
  }, [_c('b-row', {
    staticClass: "mt-5 pt-75 text-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', [_vm._v("You still have a question?")]), _c('b-card-text', {
    staticClass: "mb-3"
  }, [_vm._v(" If you cannot find a question in our FAQ, you can always contact us. We will answer to you shortly! ")])], 1), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('b-card', {
    staticClass: "shadow-none py-1 faq-contact-card"
  }, [_c('XdeskView', {
    attrs: {
      "details": _vm.xdeskUser,
      "is-admin": false,
      "secret-key": "secret-6m245chapl706m5ijqpk4p612",
      "set-loader": _vm.setLoading,
      "is-loading": _vm.isLoading
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('button', {
    staticClass: "btn btn-success w-100 d-flex align-items-center justify-content-center"
  }, [_vm.isLoading ? [_c('span', {
    staticClass: "spinner-border spinner-border-sm"
  })] : [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "HelpCircleIcon",
      "size": "18"
    }
  }), _vm._v(" Support ")]], 2)])], 1)], 1), _c('br'), _c('span', {
    staticClass: "text-body"
  }, [_vm._v("We are always happy to help!")])], 1)], 1)], 1)], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }